import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../store/types";
import SbuxStyledTableRow from "../../../../../components/SbuxTable/SbuxStyledTableRow";
import SbuxStyledTableCell from "../../../../../components/SbuxTable/SbuxStyledTableCell";
import { Switch } from "@mui/material";
import {
  createOrUpdateFeatureFlags,
  getTicketOrCaseFeatureFlagEnabled,
} from "../../../../../services/featureFlags";
import { getLastUpdated } from "../../../utils";
import styles from "../../styles";
import { TICKET_OR_CASE_NUMBER } from "../../../../../constants";
import useCss from "../../../../../hooks/useCss";
import { getTimezoneSelector } from "../../../../../selectors/settingsSelector";

interface Props {
  row: Record<string, unknown>;
}

const EditFeatureFlagsRow = ({ row }: Props) => {
  const [switchToggle, setSwitchToggle] = useState(Boolean(row["enabled"]));
  const classes = useCss(styles);
  const dispatch = useAppDispatch();
  const timezone = useAppSelector(getTimezoneSelector);

  const handleSwitchChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setSwitchToggle(value);
    const updatedRow = {
      ...row,
      enabled: value,
    };
    await dispatch(createOrUpdateFeatureFlags(updatedRow));
    if (row["name"] === TICKET_OR_CASE_NUMBER) {
      await dispatch(getTicketOrCaseFeatureFlagEnabled());
    }
  };

  return (
    <SbuxStyledTableRow sx={{ "& > *": { borderBottom: "unset" } }}>
      <SbuxStyledTableCell className={classes.cellFocus}>
        {row["name"] as React.ReactNode}
      </SbuxStyledTableCell>
      <SbuxStyledTableCell className={classes.cellFocus}>
        {row["label"] as React.ReactNode}
      </SbuxStyledTableCell>
      <SbuxStyledTableCell className={classes.cellFocus}>
        <Switch
          size="small"
          checked={switchToggle}
          onChange={handleSwitchChange}
        />
      </SbuxStyledTableCell>
      <SbuxStyledTableCell>{getLastUpdated(row, timezone)}</SbuxStyledTableCell>
    </SbuxStyledTableRow>
  );
};

export default EditFeatureFlagsRow;
